import { Slot } from '@radix-ui/react-slot'
import { cva, type VariantProps } from 'class-variance-authority'
import type * as React from 'react'

import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center justify-center gap-1 border border-transparent px-2 py-0.5 text-[11px] font-medium tracking-[0.02em] whitespace-nowrap w-fit shrink-0 [&>svg]:size-3',
  {
    variants: {
      variant: {
        default: 'bg-steel-100 text-steel-800',
        secondary: 'bg-neutral-100 text-neutral-800',
        outline: 'border-steel text-steel-700',
        muted: 'bg-neutral-100 text-neutral-700',
        warning: 'border-warning/40 bg-warning/10 text-warning',
        destructive: 'border-destructive/40 bg-destructive/10 text-destructive',
        success: 'border-success/40 bg-success/10 text-success',
      },
    },
    defaultVariants: { variant: 'default' },
  },
)

function Badge({
  className,
  variant,
  asChild = false,
  ...props
}: React.ComponentProps<'span'> & VariantProps<typeof badgeVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot : 'span'
  return <Comp className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
